export function isAddressFilled(get: (path: string) => any, propertyType?: string): boolean {
    const fields = [
        "property.location.address.street",
        "property.location.address.postalCode",
        "property.location.address.locality"
    ];

    // Require address number unless it's LAND
    if (propertyType?.toLocaleLowerCase() !== "land") {
        fields.push("property.location.address.number");
    }

    return fields.every(f => !!get(f));
}
